import { jsxs, jsx } from 'react/jsx-runtime';
import React, { createElement } from 'react';
import { useMediaQuery, Tabs, Tab, Box, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Snackbar, Slide, Typography, Button, Accordion, AccordionSummary, FormControlLabel, Checkbox, AccordionDetails } from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import { grey, green } from '@material-ui/core/colors';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global_1 =
  /* global globalThis -- safe */
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var fails = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails(function () {
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var isObject = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var document = global_1.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

var documentCreateElement = function (it) {
  return EXISTS ? document.createElement(it) : {};
};

// Thank's IE8 for his funny defineProperty
var ie8DomDefine = !descriptors && !fails(function () {
  return Object.defineProperty(documentCreateElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var anObject = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var toPrimitive = function (input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var nativeDefineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var f = descriptors ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (ie8DomDefine) try {
    return nativeDefineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var objectDefineProperty = {
	f: f
};

var createPropertyDescriptor = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var createNonEnumerableProperty = descriptors ? function (object, key, value) {
  return objectDefineProperty.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var hasOwnProperty = {}.hasOwnProperty;

var has = function (it, key) {
  return hasOwnProperty.call(it, key);
};

var setGlobal = function (key, value) {
  try {
    createNonEnumerableProperty(global_1, key, value);
  } catch (error) {
    global_1[key] = value;
  } return value;
};

var SHARED = '__core-js_shared__';
var store = global_1[SHARED] || setGlobal(SHARED, {});

var sharedStore = store;

var functionToString = Function.toString;

// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof sharedStore.inspectSource != 'function') {
  sharedStore.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

var inspectSource = sharedStore.inspectSource;

var WeakMap = global_1.WeakMap;

var nativeWeakMap = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));

var shared = createCommonjsModule(function (module) {
(module.exports = function (key, value) {
  return sharedStore[key] || (sharedStore[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.9.1',
  mode:  'global',
  copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
});
});

var id = 0;
var postfix = Math.random();

var uid = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};

var keys = shared('keys');

var sharedKey = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys = {};

var WeakMap$1 = global_1.WeakMap;
var set, get, has$1;

var enforce = function (it) {
  return has$1(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (nativeWeakMap) {
  var store$1 = sharedStore.state || (sharedStore.state = new WeakMap$1());
  var wmget = store$1.get;
  var wmhas = store$1.has;
  var wmset = store$1.set;
  set = function (it, metadata) {
    metadata.facade = it;
    wmset.call(store$1, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store$1, it) || {};
  };
  has$1 = function (it) {
    return wmhas.call(store$1, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return has(it, STATE) ? it[STATE] : {};
  };
  has$1 = function (it) {
    return has(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has$1,
  enforce: enforce,
  getterFor: getterFor
};

var redefine = createCommonjsModule(function (module) {
var getInternalState = internalState.get;
var enforceInternalState = internalState.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var state;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has(value, 'name')) {
      createNonEnumerableProperty(value, 'name', key);
    }
    state = enforceInternalState(value);
    if (!state.source) {
      state.source = TEMPLATE.join(typeof key == 'string' ? key : '');
    }
  }
  if (O === global_1) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState(this).source || inspectSource(this);
});
});

var DatePrototype = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var nativeDateToString = DatePrototype[TO_STRING];
var getTime = DatePrototype.getTime;

// `Date.prototype.toString` method
// https://tc39.es/ecma262/#sec-date.prototype.tostring
if (new Date(NaN) + '' != INVALID_DATE) {
  redefine(DatePrototype, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare -- NaN check
    return value === value ? nativeDateToString.call(this) : INVALID_DATE;
  });
}

var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var f$1 = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : nativePropertyIsEnumerable;

var objectPropertyIsEnumerable = {
	f: f$1
};

var toString = {}.toString;

var classofRaw = function (it) {
  return toString.call(it).slice(8, -1);
};

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classofRaw(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings



var toIndexedObject = function (it) {
  return indexedObject(requireObjectCoercible(it));
};

var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var f$2 = descriptors ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (ie8DomDefine) try {
    return nativeGetOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!objectPropertyIsEnumerable.f.call(O, P), O[P]);
};

var objectGetOwnPropertyDescriptor = {
	f: f$2
};

var path = global_1;

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

var getBuiltIn = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global_1[namespace])
    : path[namespace] && path[namespace][method] || global_1[namespace] && global_1[namespace][method];
};

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.es/ecma262/#sec-tointeger
var toInteger = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var max = Math.max;
var min$1 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
};

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};

var indexOf = arrayIncludes.indexOf;


var objectKeysInternal = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var hiddenKeys$1 = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
var f$3 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return objectKeysInternal(O, hiddenKeys$1);
};

var objectGetOwnPropertyNames = {
	f: f$3
};

var f$4 = Object.getOwnPropertySymbols;

var objectGetOwnPropertySymbols = {
	f: f$4
};

// all object keys, includes non-enumerable and symbols
var ownKeys = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = objectGetOwnPropertyNames.f(anObject(it));
  var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};

var copyConstructorProperties = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = objectDefineProperty.f;
  var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

var isForced_1 = isForced;

var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;






/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global_1;
  } else if (STATIC) {
    target = global_1[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global_1[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor$1(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced_1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};

var aFunction$1 = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};

// optional / simple context binding
var functionBindContext = function (fn, that, length) {
  aFunction$1(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject = function (argument) {
  return Object(requireObjectCoercible(argument));
};

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
var isArray = Array.isArray || function isArray(arg) {
  return classofRaw(arg) == 'Array';
};

var engineIsNode = classofRaw(global_1.process) == 'process';

var engineUserAgent = getBuiltIn('navigator', 'userAgent') || '';

var process = global_1.process;
var versions = process && process.versions;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] + match[1];
} else if (engineUserAgent) {
  match = engineUserAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = engineUserAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

var engineV8Version = version && +version;

var nativeSymbol = !!Object.getOwnPropertySymbols && !fails(function () {
  /* global Symbol -- required for testing */
  return !Symbol.sham &&
    // Chrome 38 Symbol has incorrect toString conversion
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    (engineIsNode ? engineV8Version === 38 : engineV8Version > 37 && engineV8Version < 41);
});

var useSymbolAsUid = nativeSymbol
  /* global Symbol -- safe */
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var WellKnownSymbolsStore = shared('wks');
var Symbol$1 = global_1.Symbol;
var createWellKnownSymbol = useSymbolAsUid ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid;

var wellKnownSymbol = function (name) {
  if (!has(WellKnownSymbolsStore, name) || !(nativeSymbol || typeof WellKnownSymbolsStore[name] == 'string')) {
    if (nativeSymbol && has(Symbol$1, name)) {
      WellKnownSymbolsStore[name] = Symbol$1[name];
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
    }
  } return WellKnownSymbolsStore[name];
};

var SPECIES = wellKnownSymbol('species');

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesCreate = function (originalArray, length) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterOut }` methods implementation
var createMethod$1 = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_OUT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = indexedObject(O);
    var boundFunction = functionBindContext(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_OUT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push.call(target, value); // filterOut
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

var arrayIteration = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod$1(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod$1(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod$1(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod$1(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod$1(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod$1(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod$1(6),
  // `Array.prototype.filterOut` method
  // https://github.com/tc39/proposal-array-filtering
  filterOut: createMethod$1(7)
};

var SPECIES$1 = wellKnownSymbol('species');

var arrayMethodHasSpeciesSupport = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return engineV8Version >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES$1] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};

var $map = arrayIteration.map;


var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');

// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
_export({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var defineProperty = objectDefineProperty.f;

var FunctionPrototype = Function.prototype;
var FunctionPrototypeToString = FunctionPrototype.toString;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if (descriptors && !(NAME in FunctionPrototype)) {
  defineProperty(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return FunctionPrototypeToString.call(this).match(nameRE)[1];
      } catch (error) {
        return '';
      }
    }
  });
}

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
var objectKeys = Object.keys || function keys(O) {
  return objectKeysInternal(O, enumBugKeys);
};

var nativeAssign = Object.assign;
var defineProperty$1 = Object.defineProperty;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !nativeAssign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (descriptors && nativeAssign({ b: 1 }, nativeAssign(defineProperty$1({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty$1(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  /* global Symbol -- required for testing */
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return nativeAssign({}, A)[symbol] != 7 || objectKeys(nativeAssign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
  var propertyIsEnumerable = objectPropertyIsEnumerable.f;
  while (argumentsLength > index) {
    var S = indexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!descriptors || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  } return T;
} : nativeAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
_export({ target: 'Object', stat: true, forced: Object.assign !== objectAssign }, {
  assign: objectAssign
});

var slice = [].slice;
var MSIE = /MSIE .\./.test(engineUserAgent); // <- dirty ie9- check

var wrap = function (scheduler) {
  return function (handler, timeout /* , ...arguments */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : undefined;
    return scheduler(boundArgs ? function () {
      // eslint-disable-next-line no-new-func -- spec requirement
      (typeof handler == 'function' ? handler : Function(handler)).apply(this, args);
    } : handler, timeout);
  };
};

// ie9- setTimeout & setInterval additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
_export({ global: true, bind: true, forced: MSIE }, {
  // `setTimeout` method
  // https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-settimeout
  setTimeout: wrap(global_1.setTimeout),
  // `setInterval` method
  // https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-setinterval
  setInterval: wrap(global_1.setInterval)
});

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var useStyles = makeStyles(function (theme) {
  return {
    container: {
      "& a": {
        color: theme.palette.text.primary,
        textDecoration: "underline",
        cursor: "pointer"
      }
    },
    snackbar: {
      "& >div": {
        background: theme.palette.background.paper,
        boxShadow: "5px 5px 26px rgba(0, 0, 0, 0.7) ",
        borderRadius: "4px",
        padding: "6px 16px",
        paddingTop: "10px",
        maxWidth: "100vw",
        overflowY: "auto",
        maxHeight: "90vh"
      }
    },
    checkBox: {
      "& svg": {
        "& path": {
          color: function color(props) {
            return props.checkBoxColor || theme.palette.secondary.light;
          }
        }
      }
    },
    accordionContainer: {
      margin: "12px 0px"
    },
    accordionDetails: {
      padding: "0px"
    },
    accordionContent: _defineProperty({}, theme.breakpoints.down("xs"), {
      flexDirection: "column"
    }),
    accordionLabel: {
      fontSize: "14px"
    },
    closeButton: {
      position: "absolute",
      right: "-14px",
      marginTop: "-20px"
    },
    buttonsContainer: {
      display: "flex",
      justifyContent: "flex-end",
      "& >button:not(:first-child)": {
        marginLeft: "10px"
      }
    },
    buttonGrey: {
      color: theme.palette.getContrastText(grey[400]),
      backgroundColor: grey[400],
      "&:hover": {
        backgroundColor: grey[600]
      }
    },
    buttonGreen: {
      color: theme.palette.getContrastText(green[600]),
      backgroundColor: green[600],
      "&:hover": {
        backgroundColor: green[500]
      }
    }
  };
});

var $filter = arrayIteration.filter;


var HAS_SPECIES_SUPPORT$1 = arrayMethodHasSpeciesSupport('filter');

// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
_export({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT$1 }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var quot = /"/g;

// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
// https://tc39.es/ecma262/#sec-createhtml
var createHtml = function (string, tag, attribute, value) {
  var S = String(requireObjectCoercible(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};

// check the existence of a method, lowercase
// of a tag and escaping quotes in arguments
var stringHtmlForced = function (METHOD_NAME) {
  return fails(function () {
    var test = ''[METHOD_NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  });
};

// `String.prototype.link` method
// https://tc39.es/ecma262/#sec-string.prototype.link
_export({ target: 'String', proto: true, forced: stringHtmlForced('link') }, {
  link: function link(url) {
    return createHtml(this, 'a', 'href', url);
  }
});

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var Property;

(function (Property) {
  Property["Necessary"] = "necessary";
  Property["Settings"] = "settings";
  Property["Statistics"] = "statistics";
  Property["Marketing"] = "marketing";
})(Property || (Property = {}));

var useStyles$1 = makeStyles(function (theme) {
  return {
    container: {},
    root: _defineProperty({
      backgroundColor: theme.palette.background.paper,
      maxHeight: 400,
      overflow: "auto"
    }, theme.breakpoints.up("sm"), {
      display: "flex"
    }),
    tabs: _defineProperty({}, theme.breakpoints.up("sm"), {
      borderRight: "1px solid ".concat(theme.palette.divider)
    }),
    tabPanel: _defineProperty({
      overflow: "auto",
      maxHeight: "100%"
    }, theme.breakpoints.up("sm"), {
      flex: 1
    }),
    table: {
      "& a": {
        color: theme.palette.text.primary,
        textDecoration: "underline"
      }
    }
  };
});

function a11yProps(index) {
  return {
    id: "vertical-tab-".concat(index),
    "aria-controls": "vertical-tabpanel-".concat(index)
  };
}

function TabPanel(props) {
  var children = props.children,
      value = props.value,
      cookieInfo = props.cookieInfo,
      texts = props.texts,
      other = __rest(props, ["children", "value", "cookieInfo", "texts"]);

  var classes = useStyles$1();
  return jsx("div", Object.assign({
    role: "tabpanel",
    className: classes.tabPanel
  }, other, {
    children: jsx(Box, Object.assign({
      p: 1
    }, {
      children: jsx(TableContainer, Object.assign({
        component: Box
      }, {
        children: jsxs(Table, Object.assign({
          className: classes.table,
          size: "small",
          "aria-label": "a dense table"
        }, {
          children: [jsx(TableHead, {
            children: jsxs(TableRow, {
              children: [jsx(TableCell, {
                children: texts === null || texts === void 0 ? void 0 : texts.name
              }, void 0), jsx(TableCell, Object.assign({
                align: "right"
              }, {
                children: texts === null || texts === void 0 ? void 0 : texts.provider
              }), void 0), jsx(TableCell, Object.assign({
                align: "right"
              }, {
                children: texts === null || texts === void 0 ? void 0 : texts.purpose
              }), void 0)]
            }, void 0)
          }, void 0), jsx(TableBody, {
            children: cookieInfo && cookieInfo.map(function (row) {
              return jsxs(TableRow, {
                children: [jsx(TableCell, Object.assign({
                  component: "th",
                  scope: "row"
                }, {
                  children: row.name
                }), void 0), jsx(TableCell, Object.assign({
                  align: "right"
                }, {
                  children: jsx("a", Object.assign({
                    href: row.provider.link,
                    target: "_blank",
                    rel: "noreferrer"
                  }, {
                    children: row.provider.name
                  }), void 0)
                }), void 0), jsx(TableCell, Object.assign({
                  align: "right"
                }, {
                  children: row.purpose
                }), void 0)]
              }, "".concat(row.name + row.provider.name));
            })
          }, void 0)]
        }), void 0)
      }), void 0)
    }), void 0)
  }), void 0);
}

function CookieTabs(props) {
  var data = props.data,
      texts = props.texts;
  var classes = useStyles$1();
  var categories = [Property.Necessary, Property.Settings, Property.Statistics, Property.Marketing];

  var _React$useState = React.useState(0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      tabValue = _React$useState2[0],
      setTabValue = _React$useState2[1];

  var isDesktop = useMediaQuery("(min-width:600px)");
  categories = React.useMemo(function () {
    return categories.filter(function (val) {
      return ((data === null || data === void 0 ? void 0 : data[val]) || []).length > 0;
    });
  }, [data]);
  return jsxs("div", Object.assign({
    className: classes.root
  }, {
    children: [jsx(Tabs, Object.assign({
      orientation: !isDesktop ? "horizontal" : "vertical",
      variant: "scrollable",
      scrollButtons: "on",
      "aria-label": "Cookie tabs",
      className: classes.tabs,
      value: tabValue,
      onChange: function onChange(event, val) {
        setTabValue(val);
      }
    }, {
      children: categories.map(function (category, index) {
        return /*#__PURE__*/createElement(Tab, Object.assign({
          label: texts === null || texts === void 0 ? void 0 : texts[category]
        }, a11yProps(index), {
          key: category
        }));
      })
    }), void 0), jsx(TabPanel, {
      texts: texts,
      cookieInfo: data === null || data === void 0 ? void 0 : data[categories[tabValue]],
      value: categories[tabValue],
      index: 0
    }, void 0)]
  }), void 0);
}

CookieTabs.defaultProps = {
  title: "Title - CookieTabs",
  data: {
    necessary: [],
    settings: [],
    statistics: [],
    marketing: []
  }
};

var createProperty = function (object, key, value) {
  var propertyKey = toPrimitive(key);
  if (propertyKey in object) objectDefineProperty.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = engineV8Version >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
_export({ target: 'Array', proto: true, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = toLength(E.length);
        if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});

var arrayMethodIsStrict = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal -- required for testing
    method.call(null, argument || function () { throw 1; }, 1);
  });
};

var $forEach = arrayIteration.forEach;


var STRICT_METHOD = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
var arrayForEach = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
} : [].forEach;

// `Array.prototype.forEach` method
// https://tc39.es/ecma262/#sec-array.prototype.foreach
_export({ target: 'Array', proto: true, forced: [].forEach != arrayForEach }, {
  forEach: arrayForEach
});

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

for (var COLLECTION_NAME in domIterables) {
  var Collection = global_1[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== arrayForEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', arrayForEach);
  } catch (error) {
    CollectionPrototype.forEach = arrayForEach;
  }
}

var providers = {
  google: {
    name: "Google",
    link: "https://google.com"
  }
};
var gtmLibs = {
  gtag: [{
    name: "_ga",
    provider: {
      name: providers.google.name,
      link: providers.google.link
    },
    purpose: "Used to distinguish users.",
    type: "statistics"
  }, {
    name: "_gid",
    provider: {
      name: providers.google.name,
      link: providers.google.link
    },
    purpose: "Used to distinguish users.",
    type: "statistics"
  }, {
    name: "_ga_<container-id>",
    provider: {
      name: providers.google.name,
      link: providers.google.link
    },
    purpose: "Used to persist session state.",
    type: "statistics"
  }, {
    name: "_gac_gb_<container-id>",
    provider: {
      name: providers.google.name,
      link: providers.google.link
    },
    purpose: "Contains campaign related information. If you have linked your Google Analytics and Google Ads accounts, Google Ads website conversion tags will read this cookie unless you opt-out.",
    type: "statistics"
  }],
  gtagAnalytics: [{
    name: "_ga",
    provider: {
      name: providers.google.name,
      link: providers.google.link
    },
    purpose: "Used to distinguish users.",
    type: "statistics"
  }, {
    name: "_gid",
    provider: {
      name: providers.google.name,
      link: providers.google.link
    },
    purpose: "Used to distinguish users.",
    type: "statistics"
  }, {
    name: "_gat",
    provider: {
      name: providers.google.name,
      link: providers.google.link
    },
    purpose: "Used to throttle request rate. If Google Analytics is deployed via Google Tag Manager, this cookie will be named _dc_gtm_<property- id>.",
    type: "statistics"
  }, {
    name: "AMP_TOKEN",
    provider: {
      name: providers.google.name,
      link: providers.google.link
    },
    purpose: "Contains a token that can be used to retrieve a Client ID from AMP Client ID service. Other possible values indicate opt-out, inflight request or an error retrieving a Client ID from AMP Client ID service.",
    type: "statistics"
  }, {
    name: "_gac_<property-id>",
    provider: {
      name: providers.google.name,
      link: providers.google.link
    },
    purpose: "Contains campaign related information for the user. If you have linked your Google Analytics and Google Ads accounts, Google Ads website conversion tags will read this cookie unless you opt-out.",
    type: "statistics"
  }],
  ga: [{
    name: "__utma",
    provider: {
      name: providers.google.name,
      link: providers.google.link
    },
    purpose: "Used to distinguish users and sessions. The cookie is created when the javascript library executes and no existing __utma cookies exists. The cookie is updated every time data is sent to Google Analytics.",
    type: "statistics"
  }, {
    name: "__utmt",
    provider: {
      name: providers.google.name,
      link: providers.google.link
    },
    purpose: "Used to throttle request rate.",
    type: "statistics"
  }, {
    name: "__utmb",
    provider: {
      name: providers.google.name,
      link: providers.google.link
    },
    purpose: "Used to determine new sessions/visits. The cookie is created when the javascript library executes and no existing __utmb cookies exists. The cookie is updated every time data is sent to Google Analytics.",
    type: "statistics"
  }, {
    name: "__utmc",
    provider: {
      name: providers.google.name,
      link: providers.google.link
    },
    purpose: "Not used in ga.js. Set for interoperability with urchin.js. Historically, this cookie operated in conjunction with the __utmb cookie to determine whether the user was in a new session/visit.",
    type: "statistics"
  }, {
    name: "__utmz",
    provider: {
      name: providers.google.name,
      link: providers.google.link
    },
    purpose: "Stores the traffic source or campaign that explains how the user reached your site. The cookie is created when the javascript library executes and is updated every time data is sent to Google Analytics.",
    type: "statistics"
  }, {
    name: "__utmv",
    provider: {
      name: providers.google.name,
      link: providers.google.link
    },
    purpose: "Used to store visitor-level custom variable data. This cookie is created when a developer uses the _setCustomVar method with a visitor level custom variable. This cookie was also used for the deprecated _setVar method. The cookie is updated every time data is sent to Google Analytics.",
    type: "statistics"
  }],
  contentExperiments: [{
    name: "__utma",
    provider: {
      name: providers.google.name,
      link: providers.google.link
    },
    purpose: "Used to determine a users inclusion in an experiment.",
    type: "statistics"
  }, {
    name: "__utmx",
    provider: {
      name: providers.google.name,
      link: providers.google.link
    },
    purpose: "Used to determine the expiry of experiments a user has been included in.",
    type: "statistics"
  }],
  optimize: [{
    name: "_gaexp",
    provider: {
      name: providers.google.name,
      link: providers.google.link
    },
    purpose: "Used to determine a user's inclusion in an experiment and the expiry of experiments a user has been included in.",
    type: "statistics"
  }, {
    name: "_opt_awcid",
    provider: {
      name: providers.google.name,
      link: providers.google.link
    },
    purpose: "Used for campaigns mapped to Google Ads Customer IDs.",
    type: "statistics"
  }, {
    name: "_opt_awmid",
    provider: {
      name: providers.google.name,
      link: providers.google.link
    },
    purpose: "Used for campaigns mapped to Google Ads Campaign IDs.",
    type: "statistics"
  }, {
    name: "_opt_awgid",
    provider: {
      name: providers.google.name,
      link: providers.google.link
    },
    purpose: "Used for campaigns mapped to Google Ads Ad Group IDs",
    type: "statistics"
  }, {
    name: "_opt_awkid",
    provider: {
      name: providers.google.name,
      link: providers.google.link
    },
    purpose: "Used for campaigns mapped to Google Ads Criterion IDs",
    type: "statistics"
  }, {
    name: "_opt_utmc",
    provider: {
      name: providers.google.name,
      link: providers.google.link
    },
    purpose: "Stores the last utm_campaign query parameter.",
    type: "statistics"
  }, {
    name: "_opt_expid",
    provider: {
      name: providers.google.name,
      link: providers.google.link
    },
    purpose: "This cookie is created when running a redirect experiment. It stores the experiment ID, the variant ID and the referrer to the page that's being redirected.",
    type: "statistics"
  }]
};

var injectGTM = function injectGTM(selected) {
  var list = [];
  selected === null || selected === void 0 ? void 0 : selected.forEach(function (val) {
    if (val in gtmLibs) {
      list = [].concat(_toConsumableArray(list), _toConsumableArray(gtmLibs[val]));
    }
  });
  return list;
};

function CookieConsent(props) {
  var checkBoxColor = props.checkBoxColor,
      _props$necessaryCallb = props.necessaryCallback,
      necessaryCallback = _props$necessaryCallb === void 0 ? function () {} : _props$necessaryCallb,
      _props$selectedCallba = props.selectedCallback,
      selectedCallback = _props$selectedCallba === void 0 ? function () {} : _props$selectedCallba,
      _props$allCallback = props.allCallback,
      allCallback = _props$allCallback === void 0 ? function () {} : _props$allCallback,
      data = props.data,
      texts = props.texts,
      privacyPolicyLink = props.privacyPolicyLink,
      privacyPolicyAction = props.privacyPolicyAction,
      plugins = props.plugins;
  var classes = useStyles({
    checkBoxColor: checkBoxColor
  });

  var _React$useState = React.useState(true),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isDisplayed = _React$useState2[0],
      setIsDisplayed = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      isVisible = _React$useState4[0],
      setVisible = _React$useState4[1];

  var cookies = {
    settings: false,
    statistics: false,
    marketing: false
  };
  var availablePlugins = {
    injectGTM: injectGTM
  };
  React.useEffect(function () {
    if (plugins) plugins.map(function (plugin) {
      var selectedPlugin = availablePlugins[plugin.name];

      if (selectedPlugin) {
        var chosenProviders = plugin.providers;
        var selectedGTMCookies = selectedPlugin(chosenProviders);
        selectedGTMCookies.map(function (cookie) {
          if (cookie.type && data) data[cookie.type].push(cookie);
          return cookie;
        });
      }

      return plugin;
    });
  }, [data]);

  var closeSnackbar = function closeSnackbar() {
    setTimeout(function () {
      return setVisible(false);
    }, 200);
    setTimeout(function () {
      return setIsDisplayed(false);
    }, 250);
  };

  var necessaryCallbackFunc = function necessaryCallbackFunc() {
    necessaryCallback();
    closeSnackbar();
  };

  var selectedCallbackFunc = function selectedCallbackFunc() {
    selectedCallback(cookies);
    closeSnackbar();
  };

  var allCallbackFunc = function allCallbackFunc() {
    allCallback();
    closeSnackbar();
  };

  React.useEffect(function () {
    setTimeout(function () {
      return setVisible(true);
    }, 450);
  }, []);
  return jsx("div", Object.assign({
    className: classes.container
  }, {
    children: isDisplayed && jsx(Snackbar, Object.assign({
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
      },
      open: isVisible,
      message: "Note archived",
      classes: {
        root: classes.snackbar
      },
      TransitionComponent: function TransitionComponent(tProps) {
        return jsx(Slide, Object.assign({}, tProps), void 0);
      }
    }, {
      children: jsxs(Box, Object.assign({
        pt: 2
      }, {
        children: [jsx(Typography, Object.assign({
          gutterBottom: true,
          variant: "h5"
        }, {
          children: texts === null || texts === void 0 ? void 0 : texts.title
        }), void 0), jsxs(Typography, Object.assign({
          variant: "subtitle2"
        }, {
          children: ["".concat(texts === null || texts === void 0 ? void 0 : texts.subTitle, " "), jsx("a", Object.assign({
            href: privacyPolicyLink,
            onClick: privacyPolicyAction,
            target: "blank"
          }, {
            children: texts === null || texts === void 0 ? void 0 : texts.privacyPolicy
          }), void 0)]
        }), void 0), jsxs(Box, Object.assign({
          m: 2,
          className: classes.buttonsContainer
        }, {
          children: [jsx(Button, Object.assign({
            onClick: necessaryCallbackFunc,
            size: "small",
            className: classes.buttonGrey,
            variant: "contained"
          }, {
            children: texts === null || texts === void 0 ? void 0 : texts.useNecessaryButtonLabel
          }), void 0), jsx(Button, Object.assign({
            onClick: selectedCallbackFunc,
            size: "small",
            className: classes.buttonGreen,
            variant: "contained"
          }, {
            children: texts === null || texts === void 0 ? void 0 : texts.allowSelectedButtonLabel
          }), void 0), jsx(Button, Object.assign({
            onClick: allCallbackFunc,
            size: "small",
            className: classes.buttonGreen,
            variant: "contained"
          }, {
            children: texts === null || texts === void 0 ? void 0 : texts.allowAllButtonLabel
          }), void 0)]
        }), void 0), jsx("div", Object.assign({
          className: classes.accordionContainer
        }, {
          children: jsxs(Accordion, Object.assign({
            elevation: 10
          }, {
            children: [jsxs(AccordionSummary, Object.assign({
              expandIcon: jsx(ExpandMore, {}, void 0),
              "aria-label": "Expand",
              "aria-controls": "additional-actions1-content",
              id: "additional-actions1-header",
              classes: {
                content: classes.accordionContent
              }
            }, {
              children: [jsx(FormControlLabel, {
                "aria-label": "Acknowledge",
                onClick: function onClick(event) {
                  return event.stopPropagation();
                },
                onFocus: function onFocus(event) {
                  return event.stopPropagation();
                },
                control: jsx(Checkbox, {
                  checked: true,
                  disabled: true,
                  classes: {
                    checked: classes.checkBox
                  }
                }, void 0),
                label: texts === null || texts === void 0 ? void 0 : texts.necessary,
                classes: {
                  label: classes.accordionLabel
                }
              }, void 0), jsx(FormControlLabel, {
                onClick: function onClick(event) {
                  return event.stopPropagation();
                },
                onFocus: function onFocus(event) {
                  return event.stopPropagation();
                },
                "aria-label": "Acknowledge",
                control: jsx(Checkbox, {
                  classes: {
                    checked: classes.checkBox
                  },
                  value: cookies.settings,
                  onChange: function onChange() {
                    cookies.settings = !cookies.settings;
                  }
                }, void 0),
                label: texts === null || texts === void 0 ? void 0 : texts.settings,
                classes: {
                  label: classes.accordionLabel
                }
              }, void 0), jsx(FormControlLabel, {
                onClick: function onClick(event) {
                  return event.stopPropagation();
                },
                onFocus: function onFocus(event) {
                  return event.stopPropagation();
                },
                "aria-label": "Acknowledge",
                control: jsx(Checkbox, {
                  classes: {
                    checked: classes.checkBox
                  },
                  value: cookies.statistics,
                  onChange: function onChange() {
                    cookies.statistics = !cookies.statistics;
                  }
                }, void 0),
                label: "".concat(texts === null || texts === void 0 ? void 0 : texts.statistics),
                classes: {
                  label: classes.accordionLabel
                }
              }, void 0), jsx(FormControlLabel, {
                onClick: function onClick(event) {
                  return event.stopPropagation();
                },
                onFocus: function onFocus(event) {
                  return event.stopPropagation();
                },
                "aria-label": "Acknowledge",
                control: jsx(Checkbox, {
                  classes: {
                    checked: classes.checkBox
                  },
                  value: cookies.marketing,
                  onChange: function onChange() {
                    cookies.marketing = !cookies.marketing;
                  }
                }, void 0),
                label: "".concat(texts === null || texts === void 0 ? void 0 : texts.marketing),
                classes: {
                  label: classes.accordionLabel
                }
              }, void 0)]
            }), void 0), jsx(AccordionDetails, Object.assign({
              classes: {
                root: classes.accordionDetails
              }
            }, {
              children: jsx(Box, Object.assign({
                width: "100%"
              }, {
                children: jsx(CookieTabs, {
                  texts: texts,
                  data: data
                }, void 0)
              }), void 0)
            }), void 0)]
          }), void 0)
        }), void 0)]
      }), void 0)
    }), void 0)
  }), void 0);
}

CookieConsent.defaultProps = {
  privacyPolicyLink: undefined,
  privacyPolicyAction: function privacyPolicyAction() {},
  texts: {
    title: "This website uses cookies",
    subTitle: "We use cookies to personalise content and ads, to provide social media features and to analyse our traffic.\n  We also share information about your use of our site with our social media, advertising and analytics\n  partners who may combine it with other information that you\u2019ve provided to them or that they\u2019ve collected\n  from your use of their services",
    useNecessaryButtonLabel: "Use necessary",
    allowSelectedButtonLabel: "Only selected",
    allowAllButtonLabel: "Allow all cookies",
    necessary: "Necessary",
    settings: "Settings",
    statistics: "Statistics",
    marketing: "Marketing",
    name: "Name",
    provider: "Provider",
    purpose: "Purpose",
    privacyPolicy: "Privacy policy"
  },
  data: {
    necessary: [],
    settings: [],
    statistics: [],
    marketing: []
  }
};

function setWithExpiry(key, value, ttl) {
  var now = new Date(); // `item` is an object which contains the original value
  // as well as the time when it's supposed to expire

  var item = {
    value: value,
    expiry: now.getTime() + ttl * 1000
  };
  localStorage.setItem(key, JSON.stringify(item));
}
function getWithExpiry(key) {
  var itemStr = localStorage.getItem(key); // if the item doesn't exist, return null

  if (!itemStr) {
    return undefined;
  } // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment


  var item = JSON.parse(itemStr);
  var now = new Date(); // compare the expiry time of the item with the current time
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access

  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return undefined
    localStorage.removeItem(key);
    return undefined;
  } // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return


  return item === null || item === void 0 ? void 0 : item.value;
}

export default CookieConsent;
export { getWithExpiry, setWithExpiry };
